import classNames from 'classnames';
import { useState, useMemo } from 'react';
import { LanguagesAbbr, Quiz, QuizQuestionOption } from '../../../../../types/working-model';
import Icon, { ICONS } from '../../../../general-ui/icon';
import './quizzes.scss';

interface QuizProps {
	quiz: Quiz;
	language: LanguagesAbbr;
}

const QuizItem: React.FC<QuizProps> = (props: QuizProps) => {
	const { quiz, language } = props;

	const [currentPage, setCurrentPage] = useState(0);

	const maxPage = useMemo(() => {
		return quiz.questions.length;
	}, [quiz.questions]);

	// if it's multiple choice and there are no selected options, return null
	if (quiz.questions[currentPage]?.multiple_choice) {
		if (!quiz.questions[currentPage]?.options?.length) return null;
		const hasNullAnswer = quiz.questions[currentPage].options.find(option => !option);
		if (hasNullAnswer) return null;
	}
	return (
		<>
			<div className="quiz-preview-card">
				<div className="quiz-preview-details">
					<p className="quiz-question-count">{quiz.questions.length} Questions</p>
					<h3 className="quiz-preview-title">{quiz.title[language]}</h3>
					{/* TODO: add the subtext to the quiz model or remove from design */}
					<p className="quiz-preview-subtext">Please take a quiz to test your knowledge</p>
				</div>
				<div className="quiz-preview-start">
					<button>Start Quiz</button>
				</div>
			</div>
			<div className="quiz-container">
				{quiz.questions?.[currentPage] && (
					<>
						<div className="quiz-title">
							{quiz.questions[currentPage].title[language]}
						</div>
						<>
							{quiz.questions[currentPage].multiple_choice ? (
								quiz.questions[currentPage].options?.map(
									(
										option: QuizQuestionOption
									) => (
										option && (
											<div className="quiz-question-option-container" key={option.quiz_question_option}>
												<div
													key={
														option.quiz_question_option
													}
													className={classNames(
														'quiz-question-option',
														{
															correct:
																option.correct,
														}
													)}
												>
													<label>
														{language && option.label[language] || option.label.base}
													</label>
													<Icon
														name={
															option.correct
																? ICONS.CHECK_CIRCLE
																: ICONS.ADD_CLOSE_CIRCLE
														}
														size={14}
														color={
															option.correct
																? 'green'
																: 'red'
														}
													/>
												</div>
											</div>
										)
									)
								)
							) : (
								<div className="quiz-text-entry">
									<textarea
										placeholder={
											'Enter your answer'
										}
									></textarea>
								</div>
							)}
						</>
					</>
				)}
				<div className={"question-paging"}>
					<button disabled={currentPage === 0} onClick={() => setCurrentPage(currentPage - 1)}>Previous</button>
					<span>{currentPage + 1}/{maxPage}</span>
					<button className="next" disabled={currentPage + 1 === maxPage} onClick={() => setCurrentPage(currentPage + 1)}>Next</button>
				</div>
			</div>
		</>
	);
};

export default QuizItem;